import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { withCookies } from "react-cookie";
import config from "../../baseConfig/index";
import ApiManager from "../../apiManager/index";
import { trans, doubleNumber } from "../../helpers/index";
import { isRetina, setSpaceAfterNLetter } from "../../helpers/index";
import { localStorageGetItem, localStorageSetItem } from "../../storage/index";
import SimpleCrypto from "simple-crypto-js";
import DefaultPage from "./Parts/DefaultPage";
import Account from "./Parts/Account";
import Services from "./Parts/Services";
import RoamingInternational from "./Parts/RoamingInternational";
import Settings from "./Parts/Settings";
import Tariffs from "./Parts/Tariffs";
import Bonus from "./Parts/Bonus";
import History from "./Parts/History";
import Payment from "./Parts/Payment";
import AddOffice from "./Parts/AddOffice";
import AutoPayment from "./Parts/AutoPayment";
import NotFoundView from "../../components/NotFound/NotFoundView";
import ErrorModal from "../Fragments/ErrorModal";
import Burger from "../Fragments/Burger";
import Loading from "../Fragments/Loading";
import ChatSDK from "../../ChatSDK";
import IdleLogout from "../../IdleLogout";

class ProfileView extends Component {
  constructor(props) {
    super(props);

    this.path = this.props.location.pathname.split("/");

    this.state = {
      loginToken: this.props.cookies.get("loginToken"),
      logoutButtonDisabled: false,
      accountData: "",
      accountList: "",
      urlPrefix: "profile",
      urlNotExist: false,
      urlExistence: false,
      pages: [],
      activeMenuItem: this.path[this.path.length - 1] || "",
      toggleAccountList: false,
      expenses: "",
      defaultExpensesDay: 6,
      defaultFromDate: "",
      defaultToDate: "",
      cover: localStorageGetItem("profileCover") || 1,
      editMyAccount: false,
      editMyAccountName: "",
      editedMyAccountName: "",
      editMyAccountNameResponse: "",
      editAccountDetachId: "",
      editAccountDetachIdList: {},
      editAccountDetachButtonLoading: false,
      editOfficesList: "",
      editDetachRemovedCount: 0,
      editMyAttachments: true,
      fbWidgetShow: false,
      showErrorModal: false,
      subActiveMenuItem: "",
      switchAccount: false,
      addOffice: {
        msisdn: "",
        mobileToken: "",
        mobileStep: 1,
        mobileTimeLife: 0,
        selectedOption: "",
        fixinName: "",
        fixinId: "",
      },
      burgerOpen: false,
    };

    this.componentIsMounted = true;
    this.timeout = null;
    this.addOfficeTimeout = null;
    this.accountListSuccess = this.accountListSuccess.bind(this);
    this.accountDataSuccess = this.accountDataSuccess.bind(this);
    this.getDetalizationExpensesSuccess =
      this.getDetalizationExpensesSuccess.bind(this);
    this.errorCallBack = this.errorCallBack.bind(this);
    this.getDecryptedToken = this.getDecryptedToken.bind(this);
    this.switchAccountSuccess = this.switchAccountSuccess.bind(this);
    this.updateParentState = this.updateParentState.bind(this);
    this.updateAccount = this.updateAccount.bind(this);
    this.refreshAccountList = this.refreshAccountList.bind(this);
    this.lifeTimeCounter = this.lifeTimeCounter.bind(this);
    this.clearAddOfficeTimer = this.clearAddOfficeTimer.bind(this);
    this.token = this.getDecryptedToken();
  }

  updateParentState(newState) {
    this.setState(newState);
  }
  componentDidMount() {
    this.token = this.getDecryptedToken();
  }
  getDecryptedToken() {
    try {
      const simpleCrypto = new SimpleCrypto(config.simpleCryptoSecretKey);
      return simpleCrypto?.decrypt(this.state.loginToken);
    } catch (e) {}
  }

  lifeTimeCounter() {
    let seconds = this.state.addOffice.mobileTimeLife,
      newState = this.state.addOffice;

    seconds--;

    newState["mobileTimeLife"] = seconds;
    this.setState(newState);

    if (seconds > -1) {
      this.addOfficeTimeout = setTimeout(this.lifeTimeCounter, 1000);
    }
  }

  reSendData() {
    this.setState({ logoutButtonDisabled: true });

    ApiManager.getRequest({}, "/csrf-token").then(
      (resolve) => {
        this.props.setTokenAction(resolve.data);
        this.setState({ _token: resolve.data.data });
        this.logout();
      },
      (reject) => {
        this.setState({ showErrorModal: true });
      }
    );
  }

  logout() {
    this.setState({ logoutButtonDisabled: true });
    ApiManager.signOut({
      _token: this.props.csrf_token.data,
      jwt: this.token,
    }).then((resolve) => {
      if (this.componentIsMounted) {
        this.setState({ logoutButtonDisabled: false });
      }
      this.props.cookies.remove("loginToken", { path: config.urlPrefix });
      this.props.history.push(config.urlPrefix);
      localStorageSetItem("activeAccount", "");
      if (resolve.data.status === "OK") {
        this.props.cookies.remove("loginToken", { path: config.urlPrefix });
        this.props.history.push(config.urlPrefix);
        localStorageSetItem("activeAccount", "");
      } else if (resolve.data.status === "UNAUTHORIZED") {
        this.props.cookies.remove("loginToken", { path: config.urlPrefix });
        this.props.history.push(config.urlPrefix);
        localStorageSetItem("activeAccount", "");
      } else if (resolve.data.status === "ERROR") {
        this.errorCallBack();
      } else if (resolve.data.status === "CSRF_TOKEN_MISMATCH") {
        this.props.cookies.remove("loginToken", { path: config.urlPrefix });
        this.props.history.push(config.urlPrefix);
        localStorageSetItem("activeAccount", "");
      } else {
        this.props.cookies.remove("loginToken", { path: config.urlPrefix });
        this.props.history.push(config.urlPrefix);
        localStorageSetItem("activeAccount", "");
      }
    }, this.errorCallBack);
    this.props.cookies.remove("loginToken", { path: config.urlPrefix });
    this.props.history.push(config.urlPrefix);
    localStorageSetItem("activeAccount", "");
  }

  componentWillMount() {
    this.initProfile();

    this.props.history.listen((location, action) => {
      if (this.componentIsMounted) {
        let path = location.pathname.split("/"),
          pathSecondParam = path[path.length - 1];

        if (location.pathname.replace("/", "") === this.state.urlPrefix) {
          this.setState({ activeMenuItem: "" }, this.checkUrl);
        } else if (pathSecondParam) {
          this.setState({ activeMenuItem: pathSecondParam }, this.checkUrl);
        }
      }
    });
    document.addEventListener(
      "keydown",
      (event) => {
        if (event.keyCode === 27 && this.state.toggleAccountList) {
          this.setState({ toggleAccountList: false });
        }
      },
      false
    );
  }

  // chatLiveChatInit() {
  //   function chatInitHook() {
  //     if (window.LiveTex) {
  //       let client_id = "16512";

  //       window.LiveTex = {
  //         onLiveTexReady: function () {
  //           //onLiveTexReady сообщает о том, что LiveTex на странице готов.
  //           window.LiveTex.setConversationAttributes(
  //             {
  //               "ID клиента": client_id,
  //               "Ссылка на CRM": "https://livetex.ru/id/" + client_id,
  //             }, //данные значения увидит сотрудник в приложении LiveTex и будут отображаться в истории в личном кабинете my.livetex.ru
  //             {} //данные значения можно будет увидеть только в личном кабинете my.livetex.ru, их можно не заполнять
  //           );
  //         },
  //       };
  //     }
  //   }

  //   chatInitHook();

  //   window["liveTex"] = true;
  //   window["liveTexID"] = 156597;
  //   window["liveTex_object"] = true;
  //   window.ltLang = localStorageGetItem("defaultLngPrefix");

  //   (function () {
  //     let t = document["createElement"]("script");
  //     t.async = true;
  //     t.src = "//cs15.livetex.ru/js/client.js";
  //     let c = document["getElementsByTagName"]("script")[0];
  //     if (c) c["parentNode"]["insertBefore"](t, c);
  //     else document["documentElement"]["firstChild"]["appendChild"](t);
  //   })();
  // }

  ltWidgetTranslations() {
    return (
      <style
        dangerouslySetInnerHTML={{
          __html: `
                .lt-widget-wrap .lt-i-label-phone .lt-i-label__hint:after {
                    content: "${trans(this.props.trans, "lt.widget.phone")}";
                }
                .lt-widget-wrap .lt-i-label-custom .lt-i-label__hint:after {
                    content: "${trans(this.props.trans, "lt.widget.email")}";
                }
                .lt-widget-wrap .lt-i-label-user .lt-i-label__hint:after {
                    content: "${trans(this.props.trans, "lt.widget.name")}";
                }
                .lt-widget-wrap .lt-i-label-text .lt-i-label__hint:after {
                    content: "${trans(this.props.trans, "lt.widget.hint")}";
                }
                .lt-widget-wrap .lt-wrapper.lt-welcome .lt-bttn:after {
                    content: "${trans(this.props.trans, "lt.widget.btn_text")}";
                }
                /* Текст на окне приветствия */
                .lt-welcome .lt-baloon__txt:after {
                    content: "${trans(
                      this.props.trans,
                      "lt.widget.baloon_txt"
                    )}";
                }
                .lt-welcome .lt-chat-header__txt:after {
                    content: "${trans(
                      this.props.trans,
                      "lt.widget.header_txt"
                    )}";
                }
                .lt-online .lt-label-block__txt:after {
                    content: "${trans(
                      this.props.trans,
                      "lt.widget.block_txt"
                    )}";
                }
                .lt-offline .lt-i-label-email .lt-i-label__hint:after {
                    content: "${trans(
                      this.props.trans,
                      "lt.widget.label_hint"
                    )}";
                }
                .lt-offline .lt-baloon__txt:after {
                    content: "${trans(
                      this.props.trans,
                      "lt.widget.start_txt"
                    )}";
                }
                .lt-offline .lt-label-block__txt:after {
                    content: "${trans(
                      this.props.trans,
                      "lt.widget.offline_block_txt"
                    )}";
                }
                .lt-offline .lt-chat-header__txt:after {
                    content: "${trans(
                      this.props.trans,
                      "lt.widget.offline_header_txt"
                    )}";
                }
                .lt-chat .lt-chat-header__txt-nickname:after {
                    content: "${trans(this.props.trans, "lt.widget.nickname")}";
                }
        
            `,
        }}
      />
    );
  }

  updateAccount() {
    this.setState({
      accountData: "",
      accountList: "",
    });

    this.updateAccountItems();
  }

  refreshAccountList() {
    this.setState({
      accountList: "",
      editAccountDetachIdList: {},
    });
    this.getAccountList();
  }

  updateAccountItems() {
    ApiManager.getRequest(
      {
        jwt: this.token,
        deviceScale: isRetina() ? 2 : 1,
      },
      "/account"
    ).then(this.accountDataSuccess, this.errorCallBack);

    this.getAccountList();
  }

  getAccountList() {
    ApiManager.getRequest(
      {
        jwt: this.token,
      },
      "/account/list"
    ).then(this.accountListSuccess, this.errorCallBack);
  }

  initProfile() {
    this.updateAccountItems();

    // Get expenses list
    // ApiManager.getRequest(
    //   this.getExpensesList(),
    //   "/detalization/expenses"
    // ).then(this.getDetalizationExpensesSuccess, this.errorCallBack);
  }

  setAccountListToState() {
    if (
      this.state.accountList !== "" &&
      this.state.accountList.status === "OK" &&
      this.state.accountList.data.accounts.length
    ) {
      let accountListState = {};

      for (let i in this.state.accountList.data.accounts) {
        accountListState[this.state.accountList.data.accounts[i]["id"]] = {
          name: "",
          editedName: "",
          edit: false,
          formResponse: "",
        };
      }

      this.setState({ editOfficesList: accountListState });
    }
  }

  getExpensesList() {
    let d = new Date(),
      fromDate = new Date(
        d.setDate(d.getDate() - this.state.defaultExpensesDay)
      ),
      toDate = new Date();

    this.setState({
      defaultFromDate:
        doubleNumber(fromDate.getDate()) +
        "." +
        doubleNumber(fromDate.getMonth() + 1) +
        "." +
        fromDate.getFullYear(),
      defaultToDate:
        doubleNumber(toDate.getDate()) +
        "." +
        doubleNumber(toDate.getMonth() + 1) +
        "." +
        toDate.getFullYear(),
    });

    fromDate =
      fromDate.getFullYear() +
      "-" +
      doubleNumber(fromDate.getMonth() + 1) +
      "-" +
      doubleNumber(fromDate.getDate());
    toDate =
      toDate.getFullYear() +
      "-" +
      doubleNumber(toDate.getMonth() + 1) +
      "-" +
      doubleNumber(toDate.getDate());

    return {
      jwt: this.token,
      from_date: fromDate,
      to_date: toDate,
      format: "json",
    };
  }

  getDetalizationExpensesSuccess(resolve) {
    if (!this.componentIsMounted) {
      return;
    }
    this.setState({
      expenses: resolve.data,
    });
  }

  checkUrl() {
    this.setState({
      urlNotExist: false,
      urlExistence: this.state.pages.indexOf(this.state.activeMenuItem) !== -1,
    });

    if (
      this.state.activeMenuItem !== "" &&
      this.state.pages.indexOf(this.state.activeMenuItem) === -1
    ) {
      this.setState({
        urlNotExist: true,
      });
    }
  }

  setPages() {
    if (this.state.accountData.hasOwnProperty("data")) {
      const menuPages = [
        "profile",
        "editAutoPayment",
        "addAutoPayment",
        "payment",
        "add-office",
        "history",
      ];

      this.state.accountData.data.menu.map((item) => {
        if (item.key !== "webview") {
          menuPages.push(item.key);
        }
        return true;
      });

      this.setState(
        {
          pages: menuPages,
        },
        this.checkUrl
      );
    }
  }

  accountDataSuccess(resolve) {
    if (this.componentIsMounted) {
      if (resolve.data.hasOwnProperty("data")) {
        resolve.data.data.menu.unshift(
          {
            icon: config.imgURLPrefix + "img/account-settings.png?v=1",
            key: "account",
            name: trans(this.props.trans, "menu.account.personal.information"),
            url: "",
          },
          {
            icon: config.imgURLPrefix + "img/screw-nut.png?v=1",
            key: "settings",
            name: trans(this.props.trans, "menu.account.settings"),
            url: "",
          }
        );
      }

      this.setState({
        accountData: resolve.data,
      });

      this.setPages();
    }
  }

  accountListSuccess(resolve) {
    if (this.componentIsMounted) {
      this.setState(
        {
          accountList: resolve.data,
        },
        this.setAccountListToState
      );
    }
  }

  errorCallBack(reject) {
    this.setState({ showErrorModal: true });
  }

  // componentWillUnmount() {
  //   this.clearLogoutTimer();
  //   this.componentIsMounted = false;

  //   this.clearAddOfficeTimer();
  // }

  // logoutTimer() {
  //   this.clearLogoutTimer();

  //   this.timeout = setTimeout(() => {
  //     if (this.state.loginToken) {
  //       this.logout();
  //     }
  //   }, config.logoutTimer);
  // }

  clearAddOfficeTimer() {
    if (this.addOfficeTimeout) {
      clearTimeout(this.addOfficeTimeout);
    }
  }

  // clearLogoutTimer() {
  //   if (this.timeout) {
  //     clearTimeout(this.timeout);
  //   }
  // }

  profileMenu(menu) {
    const isOther = this.state.accountData.data.operator === "other";
    return menu.map((item, index) => {
      let menuLink = "";
      if (item.key === "esim") {
        return null;
      }
      if (!item.submenu) {
        if (item.show_operator_name) {
          menuLink = (
            <div
              className={`list__link clear-fix db pr sprite-a${
                this.state.activeMenuItem === item.key
                  ? ` list__link--active`
                  : ``
              }`}
              to={config.urlPrefix + this.state.urlPrefix + "/" + item.key}
              onClick={() => this.setState({ burgerOpen: false })}
            >
              <img
                style={{
                  opacity: isOther ? 0.5 : 1,
                }}
                className="list__img fl db"
                src={item.icon}
                alt={item.name}
              />
              <span
                className="list__title db"
                style={{
                  paddingLeft: "60px",
                  opacity: isOther ? 0.5 : 1,
                }}
              >
                {item.name}
              </span>
              <img
                style={{
                  right: 40,
                }}
                className="list__img fl db"
                src={item.labelIconUrl}
                alt={item.name}
              />
            </div>
          );
        } else {
          menuLink = (
            <Link
              className={`list__link clear-fix db pr sprite-a${
                this.state.activeMenuItem === item.key
                  ? ` list__link--active`
                  : ``
              }`}
              to={config.urlPrefix + this.state.urlPrefix + "/" + item.key}
              onClick={() => this.setState({ burgerOpen: false })}
            >
              <img
                className="list__img fl db"
                src={item.icon}
                alt={item.name}
              />
              <span className="list__title db" style={{ paddingLeft: "60px" }}>
                {item.name}
              </span>
            </Link>
          );
        }
      } else {
        menuLink = (
          <>
            <span
              className={`list__link clear-fix db pr sprite-a${
                this.state.subActiveMenuItem === item.key
                  ? ` list__link--active list__link--submenu`
                  : ``
              }`}
              onClick={() => {
                if (this.state.subActiveMenuItem === item.key) {
                  this.setState({ subActiveMenuItem: "" });
                } else {
                  this.setState({ subActiveMenuItem: item.key });
                }
              }}
            >
              <img
                className="list__img fl db"
                src={item.icon}
                alt={item.name}
              />
              <span className="list__title db" style={{ paddingLeft: "60px" }}>
                {item.name}
              </span>
            </span>
            <div
              className={
                this.state.subActiveMenuItem === item.key
                  ? "list__submenu_show"
                  : "list__submenu_hide"
              }
            >
              {item?.submenu?.items?.map((subitem, index) => {
                if (subitem.key === "webview") {
                  return (
                    <a
                      key={index}
                      className={`list__link clear-fix db pr sprite-a`}
                      href={subitem.url.replace(/\?ref=mobile/, "")}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        className="list__img fl db"
                        src={subitem.icon}
                        alt={subitem.name}
                      />
                      <span
                        className="list__title db"
                        style={{ paddingLeft: "60px" }}
                      >
                        {subitem.name}
                      </span>
                    </a>
                  );
                }
              })}
            </div>
          </>
        );
      }

      if ((item.key === "webview" || item.key === "help") && !item.submenu) {
        menuLink = (
          <a
            className={`list__link clear-fix db pr sprite-a`}
            href={item.url.replace(/\?ref=mobile/, "")}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img className="list__img fl db" src={item.icon} alt={item.name} />
            <span className="list__title db" style={{ paddingLeft: "60px" }}>
              {item.name}
            </span>
          </a>
        );
      }
      return (
        <li className="list__item" key={index}>
          {menuLink}
        </li>
      );
    });
  }

  profileLeftSidebar() {
    if (
      this.state.accountData === "" ||
      this.state.accountData.status !== "OK"
    ) {
      return (
        <div className="main-wrapper__left-inner">
          <div className="loading"></div>
        </div>
      );
    }

    if (
      this.state.accountData.status === "ERROR" ||
      this.state.accountData.status === "APP_ERROR"
    ) {
      return <p>{this.state.accountData.message}</p>;
    }

    // let refillBtn = (
    //   <Link
    //     className="main-wrapper__info-btn btn btn--yellow db fs17 sprite-b"
    //     to={config.urlPrefix + this.state.urlPrefix + "/payment"}
    //   >
    //     {trans(this.props.trans, "profile.refill.title")}
    //   </Link>
    // );

    // if (config.env === "production") {
    //   refillBtn = "";
    // }
    let refillBtn = "";
    return (
      <div className="main-wrapper__left-inner scroller-block">
        <div className="main-wrapper__left-container">
          <section className="main-wrapper__info-box">
            <h2 className="main-wrapper__info-box-title">
              {trans(this.props.trans, "profile.main.offices.title")}
            </h2>
            <ul className="main-wrapper__info-list">
              <li className="main-wrapper__info-list-item ver-top-box">
                {this.state.accountData.data.tariff_name}
              </li>
              <li className="main-wrapper__info-list-item ver-top-box fb">
                {this.state.accountData.data.number.includes("@")
                  ? this.state.accountData.data.number
                  : setSpaceAfterNLetter(this.state.accountData.data.number, 7)}
              </li>
            </ul>
            <div className="main-wrapper__info-box-price fs24 fb">
              {this.state.accountData.data.balance +
                " " +
                this.state.accountData.data.currency}
            </div>
            {refillBtn}
          </section>

          <ul className="list">
            {this.profileMenu(this.state.accountData.data.menu)}
          </ul>
        </div>

        <button
          className={`btn btn--white db${
            this.state.logoutButtonDisabled ? " btn--loading" : ""
          }`}
          type="button"
          onClick={() => this.logout()}
          disabled={this.state.logoutButtonDisabled}
        >
          {trans(this.props.trans, "profile.logout.title")}
        </button>
      </div>
    );
  }

  switchAccount(accountId) {
    let data = {
      jwt: this.token,
      _token: this.props.csrf_token.data,
    };

    if (accountId) {
      data["id"] = accountId;
    }

    localStorageSetItem("activeAccount", accountId || "");

    ApiManager.postRequest(data, "/account/switch").then(
      this.switchAccountSuccess,
      this.errorCallBack
    );
  }

  switchAccountSuccess(resolve) {
    if (resolve.data.status === "OK") {
      let simpleCrypto = new SimpleCrypto(config.simpleCryptoSecretKey),
        newLoginToken = simpleCrypto.encrypt(resolve.data.jwt);

      this.props.cookies.set("loginToken", newLoginToken, {
        path: config.urlPrefix,
      });

      this.setState({
        loginToken: newLoginToken,
        accountData: "",
        accountList: "",
        expenses: "",
        toggleAccountList: false,
        switchAccount: true,
      });
      window.location.reload();
      this.updateAccount();
      this.setState({ switchAccount: false });
    } else if (resolve.data.status === "ERROR") {
      window.location.reload();
    }
  }

  getSwitchAccountItem(clickable, title, number, id) {
    if (clickable) {
      return (
        <button
          className="list__link db tl full-width"
          type="button"
          onClick={() => this.switchAccount(id)}
        >
          <h2 className="main-wrapper__info-box-title">{title}</h2>
          <ul className="main-wrapper__info-list">
            <li className="main-wrapper__info-list-item ver-top-box fb">
              {number}
            </li>
          </ul>
        </button>
      );
    }

    return (
      <div className="list__link list__link--active db">
        <h2 className="main-wrapper__info-box-title">{title}</h2>
        <ul className="main-wrapper__info-list">
          <li className="main-wrapper__info-list-item ver-top-box fb">
            {number}
          </li>
        </ul>
      </div>
    );
  }

  drawAccountListItems(accountListData) {
    let activeMenu = localStorageGetItem("activeAccount") || "";

    const otherAccountItems = accountListData.accounts.map((item, index) => {
      if (
        this.state.editAccountDetachIdList.hasOwnProperty(item.id) &&
        !this.state.editAccountDetachIdList[item.id]
      ) {
        return "";
      }

      let currentTitle = item.name;

      if (
        this.state.editOfficesList.hasOwnProperty(item.id) &&
        this.state.editOfficesList[item.id]["editedName"]
      ) {
        currentTitle = this.state.editOfficesList[item.id]["editedName"];
      }

      if (activeMenu === item.id) {
        return (
          <li className="list__item pr" key={index}>
            {this.getSwitchAccountItem(
              false,
              currentTitle,
              "+374" + setSpaceAfterNLetter(item.number, 2)
            )}
          </li>
        );
      }

      return (
        <li className="list__item pr" key={index}>
          {this.getSwitchAccountItem(
            true,
            currentTitle,
            "+374" + setSpaceAfterNLetter(item.number, 2),
            item.id
          )}
        </li>
      );
    });

    let mainAccount = (
      <li className="list__item pr">
        {this.getSwitchAccountItem(
          true,
          this.state.editedMyAccountName || accountListData.main_account_name,
          "+374" + setSpaceAfterNLetter(accountListData.main_account, 2)
        )}
      </li>
    );

    if (activeMenu === "" || !accountListData.accounts.length) {
      mainAccount = (
        <li className="list__item pr">
          {this.getSwitchAccountItem(
            false,
            this.state.editedMyAccountName || accountListData.main_account_name,
            accountListData.main_account.includes("@")
              ? accountListData.main_account
              : "+374" + setSpaceAfterNLetter(accountListData.main_account, 2)
          )}
        </li>
      );
    }

    return (
      <>
        {mainAccount}
        {otherAccountItems}
      </>
    );
  }

  toggleAccountListPopup() {
    let inclusionBox = "";
    const operatorName = this.state.accountData?.data?.operator;
    if (this.state.toggleAccountList) {
      if (this.state.accountList === "") {
        inclusionBox = <Loading withBox={true} />;
      } else if (
        this.state.accountList !== "" &&
        this.state.accountList.status === "ERROR"
      ) {
        inclusionBox = (
          <div className="accordion__content scroller-block">
            <p className="error-message error-message--without-lr-padding">
              {this.state.accountList.message}
            </p>
          </div>
        );
      } else if (
        this.state.accountList !== "" &&
        this.state.accountList.status === "OK"
      ) {
        inclusionBox = (
          <div
            className="accordion__content scroller-block"
            style={{
              position: "relative",
            }}
          >
            <ul className="list list--inner">
              {this.drawAccountListItems(this.state.accountList.data)}
            </ul>

            <Link
              className="btn btn--white db fs17"
              onClick={() => this.setState({ toggleAccountList: false })}
              to={config.urlPrefix + this.state.urlPrefix + "/add-office"}
              style={{
                opacity: operatorName === "other" ? 0.5 : 1,
                pointerEvents: operatorName === "other" ? "none" : "auto",
              }}
            >
              {trans(this.props.trans, "profile.offices.add_office_title")}
            </Link>
            {operatorName === "other" && (
              <img
                src={`https://www.telecomarmenia.am/api/img/menu_labels/team.png?v=1.0.0`}
                style={{
                  width: "40px",
                  height: "20px",
                  position: "absolute",
                  top: "64%",
                  right: "10%",
                }}
              />
            )}
          </div>
        );
      }
    }

    return (
      <div className="main-wrapper__account-box pr">
        <div className="accordion">
          <button
            className={`accordion__link db sprite-b sprite-a tl pr${
              this.state.toggleAccountList ? ` accordion__link--active` : ``
            }`}
            type="button"
            onClick={() => {
              this.setState({
                toggleAccountList: !this.state.toggleAccountList,
              });
            }}
          >
            <span className="table">
              <span className="table-cell">
                {trans(this.props.trans, "profile.offices.title")}
              </span>
            </span>
          </button>
          {inclusionBox}
        </div>
      </div>
    );
  }

  viewSwitcher() {
    let result = "";
    switch (true) {
      case this.state.urlNotExist:
        result = <NotFoundView />;
        break;
      case this.state.activeMenuItem === "profile":
      case this.state.activeMenuItem === "":
        result = (
          <DefaultPage
            trans={this.props.trans}
            parentState={this.state}
            csrf_token={this.props.csrf_token}
            getDecryptedToken={this.getDecryptedToken}
          />
        );
        break;
      case this.state.activeMenuItem !== "" && this.state.urlExistence:
        result = this.getViewDependRoute(this.state.activeMenuItem);
        break;
      default:
        result = <Loading />;
    }

    return result;
  }

  getViewDependRoute(routeName) {
    let result = "";

    switch (routeName) {
      case "account":
        result = (
          <Account
            trans={this.props.trans}
            parentState={this.state}
            updateParentState={this.updateParentState}
            getDecryptedToken={this.getDecryptedToken}
            csrf_token={this.props.csrf_token}
          />
        );
        break;
      case "services":
        result = (
          <Services
            trans={this.props.trans}
            parentState={this.state}
            csrf_token={this.props.csrf_token}
            getDecryptedToken={this.getDecryptedToken}
          />
        );
        break;
      case "roaming":
      case "international":
        result = (
          <RoamingInternational
            trans={this.props.trans}
            parentState={this.state}
            getDecryptedToken={this.getDecryptedToken}
          />
        );
        break;
      case "settings":
        result = (
          <Settings
            trans={this.props.trans}
            parentState={this.state}
            csrf_token={this.props.csrf_token}
            getDecryptedToken={this.getDecryptedToken}
            updateParentState={this.updateParentState}
            setTranslationsAction={this.props.setTranslationsAction}
            updateAccount={this.updateAccount}
          />
        );
        break;
      case "tariffs":
        result = (
        //   <History
        //   trans={this.props.trans}
        //   csrf_token={this.props.csrf_token}
        //   parentState={this.state}
        //   getDecryptedToken={this.getDecryptedToken}
        // />
          <Tariffs
            trans={this.props.trans}
            parentState={this.state}
            csrf_token={this.props.csrf_token}
            getDecryptedToken={this.getDecryptedToken}
          />
        );
        break;
      case "bonus":
        result = (
          <Bonus
            trans={this.props.trans}
            csrf_token={this.props.csrf_token}
            parentState={this.state}
            getDecryptedToken={this.getDecryptedToken}
          />
        );
        break;
      case "history":
        result = (
          <History
            trans={this.props.trans}
            csrf_token={this.props.csrf_token}
            parentState={this.state}
            getDecryptedToken={this.getDecryptedToken}
          />
        );
        break;
      // case "payment":
      //   result = (
      //     <Payment
      //       trans={this.props.trans}
      //       parentState={this.state}
      //       csrf_token={this.props.csrf_token}
      //       config={this.props.config}
      //       getDecryptedToken={this.getDecryptedToken}
      //     />
      //   );
      //   break;
      case "add-office":
        result = (
          <AddOffice
            trans={this.props.trans}
            parentState={this.state}
            updateParentState={this.updateParentState}
            refreshAccountList={this.refreshAccountList}
            csrf_token={this.props.csrf_token}
            config={this.props.config}
            getDecryptedToken={this.getDecryptedToken}
            lifeTimeCounter={this.lifeTimeCounter}
            clearAddOfficeTimer={this.clearAddOfficeTimer}
          />
        );
        break;
      case "addAutoPayment":
        result = (
          <AutoPayment
            trans={this.props.trans}
            parentState={this.state}
            csrf_token={this.props.csrf_token}
            setTokenAction={this.props.setTokenAction}
            getDecryptedToken={this.getDecryptedToken}
          />
        );
        break;
      case "editAutoPayment":
        result = (
          <AutoPayment
            trans={this.props.trans}
            parentState={this.state}
            csrf_token={this.props.csrf_token}
            setTokenAction={this.props.setTokenAction}
            getDecryptedToken={this.getDecryptedToken}
            edit={true}
          />
        );
        break;
      default:
        result = "";
    }

    return result;
  }

  errorModal() {
    if (!this.state.showErrorModal) {
      return "";
    }

    return (
      <ErrorModal
        title={trans(this.props.trans, "error.modal.title")}
        description={trans(this.props.trans, "error.modal.description")}
        action_text={trans(this.props.trans, "error.modal.action_text")}
      />
    );
  }

  render() {
    // this.logoutTimer();
    return (
      <div
        className={`main-wrapper main-wrapper--account${
          this.state.burgerOpen ? " menu-open" : ""
        } ${localStorageGetItem("defaultLngPrefix")}`}
      >
        <Burger
          clickCallback={() =>
            this.setState({ burgerOpen: !this.state.burgerOpen })
          }
        />

        <aside
          className={`main-wrapper__left${
            this.state.toggleAccountList ? ` main-wrapper__left--dark` : ``
          }`}
          onClick={(event) => {
            if (
              this.state.toggleAccountList &&
              /main-wrapper__left--dark/.test(event.target.className)
            ) {
              this.setState({ toggleAccountList: false });
            }
          }}
        >
          {this.toggleAccountListPopup()}
          {this.profileLeftSidebar()}
        </aside>

        <div className="main-wrapper__logo-box pr clear-fix">
          <Link
            className="main-wrapper__logo-link ver-top-box"
            to={config.urlPrefix + this.state.urlPrefix}
          >
            <img
              className="main-wrapper__account-logo ver-middle-box"
              src={config.imgURLPrefix + "img/account-logo.png"}
              alt={trans(this.props.trans, "profile.top.title")}
            />
            <span className="main-wrapper__right-title ver-middle-box fs18">
              {trans(this.props.trans, "profile.top.title")}
            </span>
          </Link>
        </div>

        <div
          className="main-wrapper__right pa"
          style={{
            backgroundImage:
              "url(" +
              config.imgURLPrefix +
              "img/cover-" +
              this.state.cover +
              ".jpg)",
          }}
        >
          <div className="main-wrapper__right-inner scroller-block pr">
            {this.viewSwitcher()}
          </div>
        </div>

        <div className="main-wrapper__bottom-group">
          <div className="main-wrapper__bottom-block clear-fix">
            <p className="main-wrapper__bottom-txt fl fs14">
              {trans(this.props.trans, "auth.bottom.title")}{" "}
              <Link
                className="main-wrapper__bottom-link"
                to={config.urlPrefix + this.state.urlPrefix}
              >
                {trans(this.props.trans, "auth.bottom.link")}
              </Link>
            </p>
            <p
              className="main-wrapper__bottom-txt fr fs14"
              style={{ marginRight: "3rem" }}
              dangerouslySetInnerHTML={{
                __html: trans(this.props.trans, "auth.copyright.text").replace(
                  /%s/,
                  new Date().getFullYear()
                ),
              }}
            />
          </div>
        </div>

        {this.errorModal()}
        {this.ltWidgetTranslations()}
        <ChatSDK />
        <IdleLogout {...this.props} logout={this.logout} />
      </div>
    );
  }
}

export default withRouter(withCookies(ProfileView));
